import { useState, ChangeEvent, forwardRef, Ref } from "react";
import { Field } from "formik";

import Icon from "../../common/Icon";
import FormikErrorMessage from "../FormikErrorMessage";

import { renderFormLabel } from "../FormikFormLine/constants";
import * as styledElements from "./FormikPasswordFieldStyles";

interface FieldProps {
  name: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const FormikPasswordField = (
  {
    placeholder,
    name,
    label,
  }: {
    placeholder: string;
    name: string;
    label?: string;
  },
  ref: Ref<HTMLInputElement> | null,
) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <styledElements.Container>
      {renderFormLabel(name, label)}
      <Field name={name} innerRef={ref}>
        {({ field }: { field: FieldProps }) => (
          <styledElements.Row>
            <input
              type={showPassword ? "text" : "password"}
              placeholder={placeholder}
              {...field}
            />
            <Icon
              src={
                showPassword
                  ? "/icons/eye_gray.svg"
                  : "/icons/eye_hide_gray.svg"
              }
              alt="see password"
              onClick={() => setShowPassword(!showPassword)}
            />
          </styledElements.Row>
        )}
      </Field>
      <FormikErrorMessage name={name} />
    </styledElements.Container>
  );
};

export default forwardRef(FormikPasswordField);
